<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii"><b>Contents</b></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/10_foreword">Foreword</a></p>
<p class="toc"><span href="#/xhtml/12_intro" title="Link target outside of Sample"><b>Introduction</b></span></p>
<p class="toc"><span href="#/xhtml/14_ch01" title="Link target outside of Sample"><b>Chris Smith Photographs</b></span></p>
<p class="toc"><span href="#/xhtml/15_ch02" title="Link target outside of Sample"><b>Michael E. Keating Photographs</b></span></p>
<p class="toc"><span href="#/xhtml/17_ack" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_contents.vue?b7b193f0